import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';

export interface TestFailureModalContext {
  getFailedTest: () => any | null;
  getFailureCommentControl: () => FormControl;
  getFailureEvidenceFiles: () => File[];
  getFailureExistingEvidenceFiles: () => any[];
  isFailureModalValid: () => boolean;
  onClose: (resetConfirmed?: boolean) => void;
  onConfirm: () => void;
  onTriggerFileInput: () => void;
  onFileSelected: (event: Event) => void;
  onRemoveFailureFile: (index: number) => void;
  onDownloadFailureFile: (file: any) => void;
  onRemoveExistingFailureFile: (index: number) => void;
  canDeleteFiles: boolean;
  canUploadFailureFile: () => boolean;
  canCloneIssue: () => boolean;
  onCloneIssue: () => void;
}

export interface TestFailureModalState {
  isOpen: boolean;
  context: TestFailureModalContext | null;
}

@Injectable({
  providedIn: 'root'
})
export class TestFailureModalService {
  private readonly stateSubject = new BehaviorSubject<TestFailureModalState>({
    isOpen: false,
    context: null
  });

  readonly state$ = this.stateSubject.asObservable();

  open(context: TestFailureModalContext): void {
    this.stateSubject.next({
      isOpen: true,
      context
    });
  }

  close(): void {
    this.stateSubject.next({
      isOpen: false,
      context: null
    });
  }
}
